import { Record } from "../../fable_modules/fable-library-js.4.24.0/Types.js";
import { obj_type, record_type, array_type, class_type } from "../../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Service_$reflection } from "../../Shared/ApiDataTypes.js";
import { now as now_1, month as month_1 } from "../../fable_modules/fable-library-js.4.24.0/Date.js";
import { map } from "../../fable_modules/fable-library-js.4.24.0/Array.js";
import { parse } from "../../fable_modules/fable-library-js.4.24.0/DateOnly.js";
import { MuiXHelpers_createElement } from "../../fable_modules/Feliz.MuiX.DatePickers.6.9.2-alpha.6/Mui.fs.js";
import { PickersDay } from "@mui/x-date-pickers/PickersDay";
import { empty, toArray, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.4.24.0/Seq.js";
import React from "react";
import { reactApi } from "../../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { useEffectWithDeps } from "../../fable_modules/Feliz.2.8.0/ReactInterop.js";
import { generateQueryString } from "../../Shared/Urls.js";
import { uncurry2, int32ToString } from "../../fable_modules/fable-library-js.4.24.0/Util.js";
import { some, unwrap, map as map_1, defaultArg, value as value_12 } from "../../fable_modules/fable-library-js.4.24.0/Option.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { testRedirect, extraCoders } from "../../Promises.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "../../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { cons, ofArray, empty as empty_1 } from "../../fable_modules/fable-library-js.4.24.0/List.js";
import { toString } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { createDisposable } from "../../fable_modules/Feliz.2.8.0/Internal.fs.js";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";

class DayProps extends Record {
    constructor(day, activities) {
        super();
        this.day = day;
        this.activities = activities;
    }
}

function DayProps_$reflection() {
    return record_type("Kundeweb.DayProps", [], DayProps, () => [["day", class_type("Fable.Core.JS.Date")], ["activities", array_type(Service_$reflection())]]);
}

function Helpers_getCurrentMonth() {
    return month_1(now_1());
}

function Components_ServerDay_Z34D0A3E8(props) {
    let isSelected;
    const array_1 = map((_arg) => _arg.PlannedDate, props.activities);
    isSelected = array_1.some((date) => {
        const plannedDate = parse(date);
        if ((plannedDate.getFullYear() === props.day.getFullYear()) && (plannedDate.getMonth() === props.day.getMonth())) {
            return plannedDate.getDate() === props.day.getDate();
        }
        else {
            return false;
        }
    });
    return MuiXHelpers_createElement(PickersDay, toList(delay(() => append(Object.entries(props), delay(() => append(singleton(["classes.selected", "calendar-selected"]), delay(() => singleton(["selected", isSelected]))))))));
}

export function Components_ActivityCalendar_Z2E686B84(components_ActivityCalendar_Z2E686B84InputProps) {
    const machineId = components_ActivityCalendar_Z2E686B84InputProps.machineId;
    const customerId = components_ActivityCalendar_Z2E686B84InputProps.customerId;
    const groupId = components_ActivityCalendar_Z2E686B84InputProps.groupId;
    let patternInput;
    const initial = Helpers_getCurrentMonth() | 0;
    patternInput = reactApi.useState(initial);
    const currentMonth = patternInput[0] | 0;
    const patternInput_1 = reactApi.useState([]);
    useEffectWithDeps(() => {
        let properties_2;
        const url = (`/api/customer-group/${groupId}/activities`) + generateQueryString(toArray(delay(() => append(singleton(["month", int32ToString(currentMonth)]), delay(() => append((customerId != null) ? singleton(["customer", int32ToString(value_12(customerId))]) : empty(), delay(() => ((machineId != null) ? singleton(["machine", int32ToString(value_12(machineId))]) : empty()))))))));
        console.debug("[Activity Calendar] Current month is:", currentMonth);
        let pr_2;
        let pr_1;
        const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Service_$reflection()), undefined, undefined);
        const data_1 = undefined;
        const caseStrategy_2 = undefined;
        const extra_2 = extraCoders;
        try {
            const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map_1((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Service_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                    let matchValue;
                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
        pr_2.then((res) => {
            if (res.tag === 0) {
                const services = res.fields[0];
                console.debug("[Activity Calendar] Got activities:", services);
                patternInput_1[1](services);
            }
            else {
                console.error(some("Failed fetching services"), res.fields[0]);
            }
        });
        return createDisposable(() => {
            console.debug("[Activity Calendar] Current month changed");
        });
    }, [groupId, currentMonth, customerId, machineId]);
    return MuiXHelpers_createElement(DateCalendar, [["readOnly", true], ["displayWeekNumber", false], ["onMonthChange", (ev) => {
        const date = ev;
        console.debug("[Activity Calendar] Calendar on month change", date);
        patternInput[1](~~(date.getMonth() + 1));
    }], ["slots", {
        day: Components_ServerDay_Z34D0A3E8,
    }], ["slotProps", {
        day: {
            activities: patternInput_1[0],
        },
    }]]);
}

